"use client";

import { createContext, useContext } from "react";

/**
 * Context for portaling trade widget footer buttons (Confirm, Swap, Connect, etc.)
 * into a fixed footer area in the MobileTradeModal.
 *
 * When the context value is non-null, consumers should use createPortal
 * to render their footer content into the provided DOM element.
 * When null (default/desktop), consumers render footer inline.
 */
export const TradeFooterPortalContext = createContext<HTMLDivElement | null>(null);

export const useTradeFooterPortal = () => useContext(TradeFooterPortalContext);
